/**
 * La tarjeta con la que se dibuja cada sección de una ficha.
 *
 * Vivía dentro de `OfferDetail` y la importaban desde ahí las fichas de al lado.
 * Ahora está sola porque una de ellas —los ajustes de página de la oferta— la
 * necesita y a su vez se dibuja DENTRO de `OfferDetail`: dejándola allí, los dos
 * archivos se importaban en círculo.
 */
import type { ReactNode } from 'react'

/**
 * Una sección de la ficha.
 *
 * Cabecera con icono y nombre, cuerpo debajo. Existe para que las nueve
 * secciones se dibujen iguales: cuando cada bloque traía su propio encabezado a
 * mano, tres de ellos medían distinto y la columna se veía torcida sin que se
 * supiera por qué.
 */
export function OfferCard({ icon, title, description, count, hint, action, danger, className, children }: {
  icon: ReactNode
  title: string
  description?: string | undefined
  /** Un número al lado del nombre, cuando lo hay que contar. */
  count?: number | undefined
  /** "Guardando…" y parientes: el estado de la sección, junto a su nombre. */
  hint?: string | undefined
  /** Botón de acción en la cabecera (ej: Editar). */
  action?: ReactNode | undefined
  /** Estilo de peligro para acciones destructivas. */
  danger?: boolean | undefined
  /** Ajustes de composición de una sección concreta, sin duplicar la tarjeta. */
  className?: string | undefined
  children: ReactNode
}) {
  return (
    <section className={`dash-offer-card${danger ? ' is-danger' : ''}${className ? ` ${className}` : ''}`}>
      <header className="dash-offer-card-head">
        <span className="dash-widget-glass-icon dash-settings-head-icon dash-ofd-section-icon" aria-hidden="true">{icon}</span>
        {description ? (
          <div className="dash-offer-card-heading">
            <h3>{title}</h3>
            <p>{description}</p>
          </div>
        ) : <h3>{title}</h3>}
        {typeof count === 'number' && count > 0 ? <span className="dash-cp-count">{count}</span> : null}
        {hint ? <em className="dash-offer-card-hint">{hint}</em> : null}
        {action}
      </header>
      <div className="dash-offer-card-body">{children}</div>
    </section>
  )
}
